// Shared dropdown-menu formula — single source of truth for every "..." menu,
// submenu, and filter dropdown in the Inbox module. Matches Dashboard's
// FilterDropdown.jsx numbers (confirmed the real in-app standard, 2026-08-19).
// Extracted after this exact object was independently copy-pasted into 3 files
// (MessageCard.jsx, LifecycleStageChip.jsx, InboxFilterDropdown.jsx) — one copy
// had already drifted (missing a line), the same class of bug as the scrollbar
// duplication earlier this session. Import and spread instead of writing a new
// inline copy.
export const DROPDOWN_PAPER_SX = {
  borderRadius: "12px",
  border: (theme) => `1px solid ${theme.palette.divider}`,
  boxShadow: (theme) => (theme.palette.mode === "dark" ? "0 8px 24px rgba(0,0,0,0.4)" : "0 8px 24px rgba(0,0,0,0.12)"),
  py: 0.5,
};

// No `mx` here deliberately — some callers use a per-item mx:0.5 inset
// directly (MessageCard.jsx's own menu items), others use an outer-wrapper-
// padding pattern instead (LifecycleStageMenuList.jsx, InboxFilterDropdown.jsx)
// where a per-item mx would just get overridden anyway. Add `mx: 0.5` on top
// via spread at the call site if that specific menu needs the per-item inset.
export const DROPDOWN_ITEM_SX = {
  fontSize: "0.85rem",
  py: 0.85,
  px: 1.5,
  mb: 0.25,
  borderRadius: "8px",
  gap: 1,
};
